import { Loader } from "@googlemaps/js-api-loader";

const API_KEY = "AIzaSyBN8jwUTB6WxxfHwmHIvBKp-HLPLw-uzQg";

let loader = null;
let initPromise = null;
let mapDiv = null;
let mapInstance = null;
let hiddenContainer = null;

function ensureLoader() {
  if (!loader) {
    loader = new Loader({ apiKey: API_KEY, version: "weekly" });
  }
  return loader;
}

export function initSharedMap(opts = {}) {
  if (initPromise) return initPromise;
  const ld = ensureLoader();
  initPromise = ld.load().then(() => {
    const google = window.google;
    // create hidden container to hold the shared map when detached
    hiddenContainer = document.createElement("div");
    hiddenContainer.style.position = "absolute";
    hiddenContainer.style.left = "-9999px";
    hiddenContainer.style.top = "-9999px";
    hiddenContainer.style.width = "1px";
    hiddenContainer.style.height = "1px";
    document.body.appendChild(hiddenContainer);

    mapDiv = document.createElement("div");
    mapDiv.style.width = "100%";
    mapDiv.style.height = (opts.height || 360) + "px";
    mapDiv.style.visibility = "hidden";
    hiddenContainer.appendChild(mapDiv);

    mapInstance = new google.maps.Map(mapDiv, {
      center: opts.center || { lat: 0, lng: 0 },
      zoom: opts.zoom || 8,
      mapTypeControl: false,
      streetViewControl: false,
      overviewMapControl: false,
      scrollwheel: false,
    });

    return { mapInstance, mapDiv };
  });
  return initPromise;
}

export async function attachSharedMap(targetEl, { latitude, longitude, zoom } = {}) {
  if (!targetEl) return;
  await initSharedMap({ center: { lat: Number(latitude || 0), lng: Number(longitude || 0) }, zoom: Number(zoom || 8) });
  if (!mapDiv || !mapInstance) return;

  // move the mapDiv into the target element
  try {
    targetEl.appendChild(mapDiv);
    mapDiv.style.visibility = "visible";
    mapDiv.style.opacity = "1";
  } catch (e) {
    // fallback: ensure it's in document
    if (hiddenContainer && !hiddenContainer.contains(mapDiv)) hiddenContainer.appendChild(mapDiv);
  }

  try {
    if (Number.isFinite(Number(latitude)) && Number.isFinite(Number(longitude))) {
      const center = { lat: Number(latitude), lng: Number(longitude) };
      mapInstance.setCenter(center);
      mapInstance.panTo(center);
    }
    if (zoom) mapInstance.setZoom(Number(zoom));
  } catch (e) {
    // silent
  }
}

export function detachSharedMap() {
  if (!mapDiv || !hiddenContainer) return;
  try {
    hiddenContainer.appendChild(mapDiv);
    mapDiv.style.visibility = "hidden";
  } catch (e) {}
}

export function getSharedMapInstance() {
  return mapInstance;
}

export default {
  initSharedMap,
  attachSharedMap,
  detachSharedMap,
  getSharedMapInstance,
};
